<template>
  <a-config-provider :locale="locale">
    <router-view></router-view>
  </a-config-provider>
</template>

<script>

import zhCN from 'ant-design-vue/es/locale/zh_CN';

export default {
  name: "App",
  data() {
    return {
      locale: zhCN,
    }
  },
  components: {},
  mounted() {
    this.pingServer();
  },
  methods: {
    async pingServer() {
      try {
        const onlineTest = await this.$api.online.fetchTest()
        if (onlineTest === 'success') this.$store.commit('isLocal', false);
        else throw ('error');
      } catch (error) {
        this.$store.commit('isLocal', true);
      }
    }
  }
};
</script>

<style></style>